/* eslint-disable */
import React, { useState, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import { TableSortLabel } from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';
import addCommas from '../utils/functions/commas';
import dayjs from 'dayjs';

const columns = [
  { id: 'date_created', label: 'วันที่สร้างรายการ', align: 'center' },
  { id: 'date_pay', label: 'วันที่ทำรายการ', align: 'center' },
  { id: 'company_name', label: 'ชื่อร้านค้า', align: 'center' },
  { id: 'order_id', label: 'เลขอ้างอิงรายการของร้านค้า', align: 'center' },
  { id: 'ref', label: 'เลขอ้างอิงรายการชำระ', align: 'center' },
  { id: 'amount', label: 'ยอดเงินชำระ', align: 'center' },
  { id: 'payment_status', label: 'สถานะ', align: 'center' },
  { id: 'pay_type', label: 'ช่องทางการชำระเงิน', align: 'center' },
];

function TableHistoryAdmin({
  ishistoryAdmin,
  handleRequestSort,
  orderDirection,
  valueToOrderBy,
  pagination,
  handlePaginationChange,
}) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const createSortHead = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handlePaginationChange('handleChangePage', newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    handlePaginationChange('handleChangeRowsPerPage', event.target.value);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  <TableSortLabel
                    active={valueToOrderBy === column.id}
                    direction={
                      valueToOrderBy === column.id
                        ? _.toLower(orderDirection)
                        : _.toLower('asc')
                    }
                    onClick={createSortHead(column.id)}
                  >
                    {column.label}
                    {valueToOrderBy === column.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {orderDirection === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(ishistoryAdmin) ? (
            <TableBody>
              {ishistoryAdmin
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={index}
                    // sx={{
                    //   '&:last-child td, &:last-child th': { border: 0 },
                    // }}
                    // className="hover:bg-gray-200 cursor-pointer"
                  >
                    <TableCell align="center">
                      {row.date_created
                        ? dayjs(row.date_created).format('DD-MM-YYYY')
                        : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.date_pay
                        ? dayjs(row.date_pay).format('DD-MM-YYYY')
                        : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.company_name ? row.company_name : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.order_id ? row.order_id : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.ref ? row.ref : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.amount ? addCommas(row.amount) : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.payment_status ? row.payment_status : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.pay_type ? row.pay_type : '-'}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.size}
        page={pagination.currPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

export default TableHistoryAdmin;
